import { Button, styled } from "@mui/material";
import ReactMarkDown from "react-markdown";

export const ChatBotFooter = styled("div")(() => ({
  fontWeight: "600",
  fontSize: "12px",
  lineHeight: "16px",
  color: "rgba(0, 0, 0, 0.6)",
}));

export const WholePageOpacity = styled("div")(({ right }) => ({
  width: "100%",
  height: "100%",
  opacity: 0.6,
  top: "0%",
  background: "rgb(245 253 255)",
  zIndex: 99,
  borderRadius: "10px",
  position: "absolute",
  right: right,
}));
export const WholePageEllipse = styled("div")(({ left }) => ({
  zIndex: 999,
  position: "absolute",
  left: left || "40%",
  top: "42%",
}));

export const InnerContainer = styled("div")(({ right }) => ({
  padding: "1rem 0px 5px",
  right: right,
  // border: "1px solid",
  position: "relative",
  width: "450px",
  height: "100%",
  borderRadius: "10px",
  boxShadow: "1px 1px 5px 3px rgb(16 24 40 / 13%)",
  background: "#F5EEFF",
}));

export const CustomDiv = styled("div")(
  ({
    position,
    margin,
    borderRadius,
    boxShadow,
    padding,
    fontSize,
    width,
    fontWeight,
    top,
    textAlign,
    background,
    bottom,
    zIndex,
    transform,
    cursor,
    border,
    height,
    overflowY,
    display,
    color,
    left,
    gap,
    right,
    customStyle,
    maxHeight,
    flexWrap,
  }) => ({
    cursor: cursor,
    position: position,
    margin: margin,
    borderRadius: borderRadius,
    boxShadow: boxShadow,
    padding: padding,
    fontSize: fontSize,
    width: width,
    fontWeight: fontWeight,
    textAlign: textAlign,
    background: background,
    top: top,
    bottom: bottom,
    zIndex: zIndex,
    transform: transform,
    border: border,
    height: height,
    overflowY: overflowY,
    color: color,
    display: display,
    left: left,
    right: right,
    gap: gap,
    maxHeight: maxHeight,
    flexWrap: flexWrap,
    ...customStyle,
  })
);

export const CustomMarkDown = styled(ReactMarkDown)(({ fontSize }) => ({
  "& p": {
    margin: "0px",
    fontSize: fontSize,
  },
  "& ul": {
    fontSize: fontSize,
  },
  "& strong": {
    fontWeight: 700,
  },
}));

export const HaileyButton = styled(Button)(() => ({
  padding: "5px",
  minWidth: "0px",
  borderRadius: "50px",

  "& svg path": {
    stroke: "#344054",
  },
  "&:hover": {
    background: "#EBE1F9",
  },
}));
